// ui/atoms/Button.tsx
import styled from "styled-components";

export const Button = styled.button<{ $variant?: "primary" | "danger" }>`
  padding: 10px 16px;
  border-radius: ${({ theme }) => theme.radius.md};
  border: none;
  cursor: pointer;
  font-weight: 500;
  color: white;

  background: ${({ theme, $variant }) =>
    $variant === "danger"
      ? theme.colors.danger
      : theme.colors.primary};

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const DangerButton = styled(Button)`
  background: ${({ theme }) => theme.colors.danger};
`;

export const PrimaryButton = styled(Button)`
  background: ${({ theme }) => theme.colors.primary};
`;